module.exports = __webpack_public_path__ + "img/top-home.66c5f086.png";